var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideScheduleImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 4.94444V1.5M9.25 4.94444V1.5M1.93056 10.1111H32.0694M1.5 13.6313C1.5 9.98883 1.5 8.16672 2.25089 6.77517C2.92987 5.53397 3.98344 4.53887 5.26133 3.93178C6.73556 3.22222 8.66444 3.22222 12.5222 3.22222H21.4778C25.3356 3.22222 27.2644 3.22222 28.7387 3.93178C30.0355 4.55522 31.0878 5.55067 31.7491 6.77344C32.5 8.16844 32.5 9.99056 32.5 13.6331V22.0926C32.5 25.7351 32.5 27.5572 31.7491 28.9488C31.0701 30.19 30.0166 31.1851 28.7387 31.7922C27.2644 32.5 25.3356 32.5 21.4778 32.5H12.5222C8.66444 32.5 6.73556 32.5 5.26133 31.7904C3.98369 31.1838 2.93015 30.1893 2.25089 28.9488C1.5 27.5538 1.5 25.7317 1.5 22.0892V13.6313Z",
    stroke: "#FCFCFC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideScheduleImg);
export default __webpack_public_path__ + "static/media/side-schedule-img.ac48f0b941a874d384cf659d8bbf4280.svg";
export { ForwardRef as ReactComponent };